/* eslint-disable camelcase */

import { apiPost, buildApiURL } from '@src/services/api';

const postFavoritePage = (data) => {
    return apiPost(
        buildApiURL('/api/v1/favorite_pages'),
        { favorite_page: data },
    );
};

export {
    postFavoritePage,
};
